module.exports = __webpack_public_path__ + "img/CosmicHiddenRares.f29c49db.png";